import { render } from "./PathwaysManageSegments.vue?vue&type=template&id=361201f9"
import script from "./PathwaysManageSegments.vue?vue&type=script&lang=js"
export * from "./PathwaysManageSegments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/PathwaysManageSegments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "361201f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('361201f9', __exports__)) {
    api.reload('361201f9', __exports__)
  }
  
  module.hot.accept("./PathwaysManageSegments.vue?vue&type=template&id=361201f9", () => {
    api.rerender('361201f9', render)
  })

}


export default __exports__